const firebaseConfig = {
    apiKey: "AIzaSyB6oyGU-u5WVBsbAaVT8FnW5ZHhkyYKnis",
    authDomain: "frozen-food-96231.firebaseapp.com",
    projectId: "frozen-food-96231",
    storageBucket: "frozen-food-96231.appspot.com",
    messagingSenderId: "32026333651",
    appId: "1:32026333651:web:2a93365f495023fa62df26"
  };

  export default firebaseConfig;